module.exports = __webpack_public_path__ + "assets/minusCircleFilled-906e19.svg";